<mat-card style="margin-left:30px;margin-top:50px;margin-right:30px">
    <mat-card-content>
        <h4>Active Rate</h4>

        <div class="container-full mt-3">
            <div class="row" style="font-weight:bold;">
                <div class="col-2">
                       
                </div>
                <div class="col-1">
                    Rate Number
                </div>
                <div class="col-2">
                    Type
                </div>
                <div class="col-2">
                    Description
                </div>
                <div class="col-1">
                    Start Date
                </div>
                <div class="col-1">
                    End Date
                </div>
                <div class="col-1">
                    Amount
                </div>
                <div class="col-1">
                    Tax
                </div>
                <div class="col-1">
                    Portal
                </div>
            </div>

            <div class="row">
                <div class="col-2">
                    <button mat-button (click)="onDisplayMode(1)">Expired</button>
                    <button mat-button  (click)="onDisplayMode(2)">Future</button>
                </div>
                <div class="col-1">
                    35
                </div>
                <div class="col-2">
                    Reserved
                </div>
                <div class="col-2">
                    Unreserved Market Rate
                </div>
                <div class="col-1">
                    1/1/24
                </div>
                <div class="col-1">
                    12/31/24
                </div>
                <div class="col-1">
                    $100.00
                </div>
                <div class="col-1">
                    $0.00
                </div>
                <div class="col-1">
                    <mat-checkbox
                    class="example-margin"
                    [checked]="false" >
                  </mat-checkbox>
                </div>
            </div>
            
            <hr />

            @if(displayMode == 1){
                <span style="font-weight: bold;color:red">Expired Rates</span>

                <div class="row" style="font-weight:bold;">
                    <div class="col-2">
                           
                    </div>
                    <div class="col-2">
                        Type
                    </div>
                    <div class="col-2">
                        Description
                    </div>
                    <div class="col-1">
                        Start Date
                    </div>
                    <div class="col-1">
                        End Date
                    </div>
                    <div class="col-1">
                        Amount
                    </div>
                    <div class="col-1">
                        Tax
                    </div>
                    <div class="col-1">
                        Portal
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-2">
                        
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/23
                    </div>
                    <div class="col-1">
                        12/31/23
                    </div>
                    <div class="col-1">
                        $90.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                      ?
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                        
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/22
                    </div>
                    <div class="col-1">
                        12/31/22
                    </div>
                    <div class="col-1">
                        $80.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                      ?
                    </div>
                </div>
            }

        


            @if(displayMode == 2){
                <span style="font-weight: bold;">Future Rates</span>
                <div class="row" style="font-weight:bold;">
                    <div class="col-2">
                        
                    </div>
                    <div class="col-2">
                        Type
                    </div>
                    <div class="col-2">
                        Description
                    </div>
                    <div class="col-1">
                        Start Date
                    </div>
                    <div class="col-1">
                        End Date
                    </div>
                    <div class="col-1">
                        Amount
                    </div>
                    <div class="col-1">
                        Tax
                    </div>
                    <div class="col-1">
                        Portal
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-2">
                    </div>
                    <div class="col-2">
                        Reserved
                    </div>
                    <div class="col-2">
                        Unreserved Market Rate
                    </div>
                    <div class="col-1">
                        1/1/25
                    </div>
                    <div class="col-1">
                        12/31/25
                    </div>
                    <div class="col-1">
                        $125.00
                    </div>
                    <div class="col-1">
                        $0.00
                    </div>
                    <div class="col-1">
                      ?
                    </div>
                </div>
            }
        </div>


    </mat-card-content>
</mat-card>
